import { motion } from "framer-motion";
import { Crosshair, Radar, Zap } from "lucide-react";

const INDICATORS = [
  {
    name: "Señales Falcons",
    tagline: "85% Win Rate",
    desc: "Canal de señales con precisión comprobada. Historial público y estadística diaria.",
    icon: Radar,
  },
  {
    name: "Honor Sniper",
    tagline: "Scalping preciso",
    desc: "Nuestro indicador ideal para estrategias intraday y scalping quirúrgico.",
    icon: Crosshair,
  },
  {
    name: "Lanza de Neptuno",
    tagline: "Detección automática",
    desc: "Detecta automáticamente las mejores oportunidades del mercado. Disponible en TradingView.",
    icon: Zap,
  },
];

export default function Indicators() {
  return (
    <section
      id="indicadores"
      className="relative py-24 md:py-32 bg-[#060806]"
      data-testid="indicators-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
            / Indicadores
          </span>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
            Armamento <span className="italic text-[#BEDD7D]">exclusivo</span>
            <br />
            para cada batalla.
          </h2>
          <p className="mt-6 text-white/60 font-body">
            Automatización de detección de entradas con indicadores propietarios diseñados
            por el equipo Honor.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {INDICATORS.map((ind, i) => (
            <motion.div
              key={ind.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group relative rounded-2xl border border-[#3E4D36]/50 bg-[#1A2E1A]/30 p-8 hover:border-[#BEDD7D]/60 hover:bg-[#1A2E1A]/60 transition-all overflow-hidden"
              data-testid={`indicator-${ind.name.toLowerCase().replace(/ /g, "-")}`}
            >
              <div className="w-14 h-14 rounded-xl bg-black border border-[#BEDD7D]/30 flex items-center justify-center mb-6 group-hover:border-[#BEDD7D] transition-colors">
                <ind.icon className="w-6 h-6 text-[#BEDD7D]" />
              </div>
              <div className="text-[11px] font-display uppercase tracking-[0.3em] text-[#BEDD7D]">
                {ind.tagline}
              </div>
              <h3 className="mt-2 font-display font-bold text-2xl md:text-3xl uppercase tracking-tight">
                {ind.name}
              </h3>
              <p className="mt-4 text-white/70 font-body text-sm leading-relaxed">{ind.desc}</p>

              <div className="mt-6 inline-flex items-center gap-2 text-xs font-display uppercase tracking-widest text-white/50 group-hover:text-[#BEDD7D] transition-colors">
                24/7 Operativo
                <span className="w-1.5 h-1.5 rounded-full bg-[#BEDD7D] animate-pulse" />
              </div>

              <div
                className="absolute -bottom-24 -right-24 w-48 h-48 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
                style={{ background: "radial-gradient(circle, rgba(190,221,125,0.15), transparent 70%)" }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
